import { Input } from "antd";
import { ReactComponent as SearchIcon } from "../../../images/icons/section-icons/search-icon.svg";

const MaliciousIpHeader = ({ filter, setFilter }) => (
  <div className="malicious-header-block">
    <div className="malicious-header-block__search-wrapper">
      <Input
        placeholder="Search by IP..."
        onChange={(e) => setFilter(e.target.value)}
        allowClear
        prefix={<SearchIcon />}
        value={filter.searchValue}
        className="filter-input__search"
      />
    </div>
  </div>
);

export default MaliciousIpHeader;
